import type {Schema} from 'schemaDefinition/types';
import type {ThesaurusId} from 'services/thesaurus/types';
import {visitSchemaParts} from 'schemaDefinition/functions/visitSchemaParts';

export const getSchemaListThesaurusIds = (schemas: Schema[]): ThesaurusId[] => {
  const acutalSchemas = schemas.filter(Boolean) as Schema[];
  if (acutalSchemas.length === 0) {
    return [];
  }

  const thesaurusIds: ThesaurusId[] = [];

  acutalSchemas.forEach(schema =>
    visitSchemaParts(schema, part => {
      if (part.type === 'thesaurus') {
        if (!thesaurusIds.includes(part.thesaurusId)) {
          thesaurusIds.push(part.thesaurusId);
        }
        thesaurusIds.push(part.thesaurusId);
      }
    }),
  );

  return thesaurusIds;
};
